<template>
    <div>
        <h2>编辑(修改)个人资料</h2>
        <div class="content">
            <div>上次登录时间：{{ vuex_userInfo.loginDate }}</div>
            <div><span class="name">异地登录提醒</span><span>邮件通知</span></div>
            <div><span class="name">用户名</span>{{ vuex_userInfo.userName }}</div>
            <div><span class="name">用户UID: </span> <span> {{ vuex_userInfo.userId }} </span></div>
            <div><span class="name">登录密码: {{ vuex_userInfo.password || '暂无' }}</span> <span class="btn"
                    @click="edit('password')">修改</span></div>
            <div><span class="name">密保手机:</span>{{ vuex_userInfo.phonenumber || '暂无' }} <span class="btn"
                    @click="edit('phonenumber')">修改</span></div>
            <div><span class="name">密保邮箱:</span>{{ vuex_userInfo.email }} <span class="btn"
                    @click="edit('email')">修改</span></div>
            <div>
                <span class="name">修改头像:</span>
                <img class="avatar" :src="$img(vuex_userInfo.avatar)" alt="">
                <el-upload action="" :http-request="chooseFile" :show-file-list="false"><span
                        class="btn">修改</span></el-upload>
                <!-- <span class="btn" @click="edit('avatar')">修改</span> -->
            </div>
            <div class="q_w"><span class="name">绑定社交:</span>
                <div> QQ {{ vuex_userInfo.userAccount.qqNumber || '暂无' }} <span class="btn"
                        @click="edit('qqNumber')">立即绑定</span> </div>
                <div> 微信 {{ vuex_userInfo.userAccount.wechatNumber || '暂无' }} <span class="btn"
                        @click="edit('wechatNumber')">立即绑定</span> </div>
            </div>
            <div>
                <span class="name">姓名： {{ vuex_userInfo.userAccount.identityCardName || '暂无' }}</span>
                <span class="btn" @click="$router.push('/personalCenter/userinfo/smrz')">去实名认证</span>
                <span class="tips">一旦实名认证将不能修改，并且要和提现银行卡/微信/支付宝的姓名一致</span>
            </div>
            <div><span class="name">身份证号：{{ vuex_userInfo.userAccount.identityCardNo || '暂无' }}</span>
                <span class="btn" @click="$router.push('/personalCenter/userinfo/smrz')">去实名认证</span>
                <span class="tips">一旦实名认证将不能修改</span>
            </div>
            <div>
                <span class="name">微信收款码:</span>
                <img class="qr-img" v-if="vuex_userInfo.userAccount.wechatQrCode"
                    :src="$img(vuex_userInfo.userAccount.wechatQrCode)" alt="微信收款码">
                <span v-else>暂无</span>
                <el-upload action="" :http-request="chooseWechatQr" :show-file-list="false"><span
                        class="btn">上传</span></el-upload>
                <span v-if="vuex_userInfo.userAccount.wechatQrCode" class="btn" @click="deleteWechatQr">删除</span>
            </div>
            <div>
                <span class="name">支付宝收款码:</span>
                <img class="qr-img" v-if="vuex_userInfo.userAccount.alipayQrCode"
                    :src="$img(vuex_userInfo.userAccount.alipayQrCode)" alt="支付宝收款码">
                <span v-else>暂无</span>
                <el-upload action="" :http-request="chooseAlipayQr" :show-file-list="false"><span
                        class="btn">上传</span></el-upload>
                <span v-if="vuex_userInfo.userAccount.alipayQrCode" class="btn" @click="deleteAlipayQr">删除</span>
            </div>
            <div>
                座右铭/箴言：{{ vuex_userInfo.userAccount.motto || '这个人很懒什么都没有留下' }} <span class="btn"
                    @click="popupMotto.show = true">更多</span>
            </div>
            <!-- <div><span class="name">提现密码:</span>  <span class="btn" @click="edit('withdraw_password')">修改</span></div> -->
            <div>注册时间：{{ vuex_userInfo.createTime }}</div>
        </div>

        <el-dialog title="编辑" :visible.sync='visibleSync' custom-class="shiming-edit-dialog" append-to-body>
            <el-form>
                <!-- <el-form-item label="用户名" v-if="status == 'userName'"> <el-input v-model="statusValue" placeholder=""></el-input> </el-form-item> -->
                <template v-if="status == 'password'">
                    <el-form-item label="新登录密码"> <el-input v-model="form.password" placeholder=""></el-input>
                    </el-form-item>
                    <el-form-item label="旧登录密码"> <el-input v-model="form.oldPassword" placeholder=""></el-input>
                    </el-form-item>
                </template>


                <el-form-item label="密保手机" v-if="status == 'phonenumber'"> <el-input v-model="form.phonenumber"
                        placeholder=""></el-input> </el-form-item>
                <el-form-item label="密保邮箱" v-if="status == 'email'"> <el-input v-model="form.email"
                        placeholder=""></el-input>
                </el-form-item>
                <!-- <el-form-item label="修改头像" v-if="status == 'avatar'">
                    <br/>
                    <el-upload action="" :onChange="chooseFile" :file-list="fileList" list-type="picture-card">
                        <div class="el-icon-plus" style=" fontSize:130px; border:1px solid rgba(0,0,0,.2); color:rgba(0,0,0,.2); " ></div>
                    </el-upload>
                </el-form-item> -->
                <el-form-item label="绑定qq" v-if="status == 'qqNumber'"> <el-input v-model="form.userAccount.qqNumber"
                        placeholder=""></el-input> </el-form-item>
                <el-form-item label="绑定微信" v-if="status == 'wechatNumber'"> <el-input
                        v-model="form.userAccount.wechatNumber" placeholder=""></el-input> </el-form-item>
                <!-- <el-form-item label="身份证号"> <el-input placeholder=""></el-input> </el-form-item> -->
                <el-form-item label="提现密码" v-if="status == 'withdraw_password'"> <el-input v-model="statusValue"
                        placeholder=""></el-input> </el-form-item>
            </el-form>
            <el-button type="primary" @click="upload_userInfo">确定</el-button>
        </el-dialog>

        <el-dialog title="请选择您喜欢的座右铭" :visible.sync="popupMotto.show" width="60%"
            :before-close="e => popupMotto.show = false">

            <el-input placeholder="请输入您自定义的彩票箴言" v-model="form.userAccount.motto" style="margin-bottom:30px"></el-input>
            <div class="mottoList">
                <div v-for="(item, index) of popupMotto.motto" :key="index"
                    :class="{ active: popupMotto.active == index }" @click="
                        popupMotto.active = index;
                    form.userAccount.motto = popupMotto.motto[popupMotto.active]
                        ">{{ item }}</div>
            </div>


            <span slot="footer" class="dialog-footer">
                <el-button type="primary" @click="upload_userInfo">确 定</el-button>
            </span>
        </el-dialog>

    </div>
</template>

<script>
import motto from "@/views/personalCenter/hangjiaguanli/motto/motto.js"
import { editCurrentUser } from '@/api/personalCenter.js'
import { getInfo } from '@/api/home'
import { queryUuIdInfo } from '@/api/common'
export default {
    data() {
        return {
            popupMotto: {
                show: false,
                motto,
                active: null,
            },


            visibleSync: false,

            status: '',
            statusValue: '',

            form: {
                avatar: null,
                email: null,
                phonenumber: null,
                sex: null,
                password: '',
                oldPassword: '',
                userAccount: {
                    qqNumber: null,
                    wechatNumber: null,
                    // motto: null,
                }
            },

            fileList: [{}]
        }
    },
    mounted() {
        this.fetchUserInfo()
    },
    // 路由被 keep-alive 缓存时，每次进入也会触发
    activated() {
        this.fetchUserInfo()
    },
    methods: {
        // 进入页面实时拉取最新用户信息（不依赖登录时缓存）
        async fetchUserInfo() {
            const res = await getInfo()
            if (res.code === 200) {
                this.$vuex("vuex_userInfo", res.data.user)
                this.form = this.vuex_userInfo
            }
        },
        mottoConfirm() {
            this.popupMotto.show = false
            this.$alert('需要后台修改接口后才可以生效', '提示', {
                type: 'error',
            }).then(res => {
            })

        },

        async chooseFile(e) {

            console.log('e', e);

            let bizId = await queryUuIdInfo()

            const data = { file: e.file };


            this.fileList.push({ url: this.$utils.fileToBolb(e.file) })
            this.vuex_userInfo.avatar = this.$utils.fileToBolb(e.file)
            this.$vuex("vuex_userInfo", this.vuex_userInfo);

            let params = `?fileType=avatar&bizId=${bizId}&number=1`

            // console.log('params',params);
            this.$utils.upLoadFile(params, data).then(res => {
                // console.log('res',res.data);
                let { urls } = res.data
                this.form.avatar = urls
                this.upload_userInfo()
            })

        },
        // 微信收款码上传
        async chooseWechatQr(e) {
            let bizId = await queryUuIdInfo()
            const data = { file: e.file }
            let params = `?fileType=wechatQrCode&bizId=${bizId}&number=1`
            this.$utils.upLoadFile(params, data).then(res => {
                let { urls } = res.data
                this.form.userAccount.wechatQrCode = urls
                this.upload_userInfo()
            })
        },
        // 支付宝收款码上传
        async chooseAlipayQr(e) {
            let bizId = await queryUuIdInfo()
            const data = { file: e.file }
            let params = `?fileType=alipayQrCode&bizId=${bizId}&number=1`
            this.$utils.upLoadFile(params, data).then(res => {
                let { urls } = res.data
                this.form.userAccount.alipayQrCode = urls
                this.upload_userInfo()
            })
        },
        // 删除微信收款码
        deleteWechatQr() {
            this.$confirm('确定删除微信收款码吗？删除后该字段将被置为空', '提示', {
                confirmButtonText: '确定',
                cancelButtonText: '取消',
                type: 'warning'
            }).then(() => {
                this.form.userAccount.wechatQrCode = null
                this.upload_userInfo()
            }).catch(() => { })
        },
        // 删除支付宝收款码
        deleteAlipayQr() {
            this.$confirm('确定删除支付宝收款码吗？删除后该字段将被置为空', '提示', {
                confirmButtonText: '确定',
                cancelButtonText: '取消',
                type: 'warning'
            }).then(() => {
                this.form.userAccount.alipayQrCode = null
                this.upload_userInfo()
            }).catch(() => { })
        },
        edit(type) {
            console.log('type', type);
            this.status = type
            this.visibleSync = true
        },
        upload_userInfo() {

            // console.log('this.form', JSON.parse(JSON.stringify(this.form)));

            editCurrentUser(this.form).then(res => {
                if (res.code == 200) {
                    this.$message.success('修改成功')
                    this.visibleSync = false
                    this.popupMotto.show = false
                    // 深拷贝换新引用，确保 vuex_userInfo 触发响应式刷新（原 this.form 与旧 vuex_userInfo 是同一引用，直接赋值不会重渲染）
                    this.$vuex("vuex_userInfo", JSON.parse(JSON.stringify(this.form)));
                    // 重新拉取后台最新数据，保证与后台一致
                    this.fetchUserInfo()
                } else {
                    this.$message.error(res.msg)
                }

            })


            function checkEmpty(obj) {
                for (let key in obj) {
                    if (obj.hasOwnProperty(key)) {
                        if (typeof obj[key] === 'object' && obj[key] !== null) {
                            if (checkEmpty(obj[key])) {
                                return true;
                            }
                        } else if (obj[key] === '') {
                            return true;
                        }
                    }
                }
                return false;
            }

            // let userInfo = JSON.parse(localStorage.getItem('userInfo'))
            // this.$http.post('/update/userinfo',{
            //     user_id:userInfo.user_id,
            //     [this.status]:this.statusValue,
            // }).then(res=>{
            //     console.log('res',res);
            //     if(res.status == 200){
            //         userInfo[this.status] = this.statusValue
            //         localStorage.setItem('userInfo',JSON.stringify(userInfo))
            //         this.visibleSync = false
            //         this.statusValue = ''
            //         this.$message.success('修改成功')
            //     }
            // })
        }
    }
};
</script>

<style lang="scss" scoped>
.btn {
    cursor: pointer;
}

.mottoList {
    height: 50vh;
    overflow-y: scroll;
    border-top: 1px solid rgba(0, 0, 0, 0.1);

    >div {
        height: 40px;
        line-height: 40px;
        border-bottom: 1px solid rgba(0, 0, 0, 0.1);
        cursor: pointer;

        &.active {
            background-color: #409EFF;
            color: #fff;
        }
    }
}

.content {
    border: 1px solid rgba(0, 0, 0, 0.07);
    font-size: 15px;

    >div {
        display: flex;
        align-items: center;
        border-bottom: 1px solid rgba(0, 0, 0, 0.07);
        padding: 10px;

        .avatar {
            width: 50px;
            height: 50px;
            border-radius: 50%;
            background: rgba(0, 0, 0, 0.07);
        }

        .qr-img {
            width: 80px;
            height: 80px;
            object-fit: contain;
            background: rgba(0, 0, 0, 0.07);
            margin-left: 10px;
        }

        &.q_w {
            >div {
                margin-right: 50px;

                span {
                    margin-left: 10px;
                }
            }
        }

        .name {
            display: inline-block;
            margin-right: 35px;
        }
    }

    .tips {
        color: #a36b54;
        font-weight: bold;
        margin-left: 30px;
    }

    .btn {
        border: 1px solid #efc085;
        background-color: #fbeedc;
        color: #aa7035;
        display: inline-block;
        padding: 3px 10px;
        border-radius: 5px;
        margin-left: 20px;
    }
}

/* ===== 移动端适配（屏幕小于 1200px 即生效） ===== */
@media (max-width: 1200px) {
    .content {
        font-size: 14px;

        /* 每行允许换行，标签/值/按钮不再挤在一行 */
        >div {
            flex-wrap: wrap;
            row-gap: 8px;
            padding: 10px 8px;

            /* 字段名：固定宽度，右侧值对齐成一列 */
            .name {
                flex: none;
                min-width: 82px;
                margin-right: 10px;
                color: #347caf;
                font-weight: 700;
            }

            .btn {
                margin-left: 0;
                margin-right: 12px;
            }

            .qr-img {
                width: 64px;
                height: 64px;
                margin-left: 0;
            }

            .avatar {
                width: 44px;
                height: 44px;
            }
        }

        /* 说明文字：单独占一行 */
        .tips {
            width: 100%;
            margin-left: 0;
            font-size: 12px;
            font-weight: normal;
            line-height: 1.7;
        }

        /* 绑定社交：QQ / 微信各占一行 */
        >div.q_w {
            >div {
                width: 100%;
                margin-right: 0;

                span {
                    margin-left: 6px;
                }
            }
        }
    }
}
</style>

<style lang="scss">
/* 编辑弹窗：append-to-body 挂到 body，作用域样式无法命中，改用全局样式 */
.shiming-edit-dialog {

    .el-form-item {
        display: block;
        margin-bottom: 14px;
    }

    .el-form-item__label {
        float: none;
        display: block;
        width: auto !important;
        padding: 0 0 6px;
        line-height: 1.6;
        text-align: left;
        color: #347caf;
        font-weight: 700;
    }

    .el-form-item__content {
        margin-left: 0 !important;
        line-height: 1.6;
    }

    .el-input {
        width: 100% !important;
    }
}

/* 移动端：编辑弹窗表单改为上下结构 */
@media (max-width: 1200px) {
    .shiming-edit-dialog {

        .el-form-item {
            display: block;
            margin-bottom: 14px;
        }

        .el-form-item__label {
            float: none;
            display: block;
            width: auto !important;
            padding: 0 0 6px;
            line-height: 1.6;
            text-align: left;
        }

        .el-form-item__content {
            margin-left: 0 !important;
            line-height: 1.6;
        }

        .el-input {
            width: 100% !important;
        }
    }
}
</style>
